<template>
  <div class="warehouse-component">
    <!-- 新增：操作按钮区域 -->
    <div class="operation-buttons">
      <el-button 
        type="primary" 
        icon="el-icon-plus" 
        size="mini"
        @click="handleCreateInbound"
      >
        创建出库单
      </el-button>
      <el-button 
        type="primary" 
        icon="el-icon-download" 
        size="mini"
        @click="handleBatchInbound"
		:disabled="true"
      >
        批量出库
      </el-button>
	  <!-- 出库信息导出按钮 -->
	  <el-button type="success" size="mini" icon="el-icon-download" @click="handleExport"
	  	:loading="exportLoading" :disabled="true">
	  	出库信息导出
	  </el-button>
    </div>
    
    <!-- 表格区域 -->
    <el-table
      :data="tableData"
      style="width: 100%"
      stripe
      border
      size="mini"
      height="calc(100vh - 420px)"
      v-loading="loading"
      :default-sort="{prop: 'date', order: 'descending'}"
    >
      <el-table-column
        type="index"
        label="#"
        width="50"
        align="center"
        fixed
      ></el-table-column>
      
      <el-table-column
        prop="state"
        label="状态"
        width="80"
        align="center"
		fixed
      >
        <template slot-scope="scope">
          <el-tag
            :type="getStatusTagType(scope.row.state)"
            size="mini"
          >
            {{ getStatusText(scope.row.state) }}
          </el-tag>
        </template>
      </el-table-column>
      
      <el-table-column
        prop="docNum"
        label="出库单号"
        min-width="200"
        sortable
      >
        <template slot-scope="scope">
          <el-link
            type="primary"
            :underline="false"
            @click="handleView(scope.row)"
            class="doc-num-link"
          >
            {{ scope.row.docNum }}
          </el-link>
        </template>
      </el-table-column>
      
      <el-table-column
        prop="retnTypeName"
        label="出库类型"
        width="110"
        align="center"
      >
        <template slot-scope="scope">
          <el-tag
            :type="getTypeTagType(scope.row.retnTypeName)"
            size="mini"
          >
            {{ scope.row.retnTypeName || '--' }}
          </el-tag>
        </template>
      </el-table-column>
      
      <el-table-column
        prop="supplierName"
        label="供应商"
        min-width="150"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          {{ scope.row.supplierName || '--' }}
        </template>
      </el-table-column>
      
      <el-table-column
        prop="saleAmt"
        label="成本金额"
        width="120"
        align="right"
      >
        <template slot-scope="scope">
          <span class="amount">¥{{ formatAmount(scope.row.costAmt) }}</span>
        </template>
      </el-table-column>
      
      <!-- 新增字段 -->
      <el-table-column
        prop="createName"
        label="创建人"
        width="100"
        align="center"
      >
        <template slot-scope="scope">
          {{ scope.row.createName || '--' }}
        </template>
      </el-table-column>
      
      <el-table-column
        prop="createTime"
        label="创建时间"
        width="150"
        align="center"
      >
        <template slot-scope="scope">
          {{ formatTime(scope.row.createTime) }}
        </template>
      </el-table-column>
      
      <el-table-column
        prop="passingOrdersName"
        label="过单人"
        width="100"
        align="center"
      >
        <template slot-scope="scope">
          {{ scope.row.passingOrdersName || '--' }}
        </template>
      </el-table-column>
      
      <el-table-column
        prop="passingOrdersTime"
        label="过单时间"
        width="150"
        align="center"
      >
        <template slot-scope="scope">
          {{ formatTime(scope.row.passingOrdersTime) }}
        </template>
      </el-table-column>
      
      <el-table-column
        prop="remarks"
        label="备注"
        min-width="150"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          {{ scope.row.remarks || '--' }}
        </template>
      </el-table-column>
      
      <el-table-column
        label="操作"
        width="220"
        align="center"
        fixed="right"
      >
        <template slot-scope="scope">
          <!-- 详情按钮（所有状态都显示） -->
          <el-button
            type="text"
            size="mini"
            @click="handleView(scope.row)"
          >
            详情
          </el-button>
          
          <!-- 根据状态显示不同按钮 -->
          <template v-if="scope.row.state === 0">
            <!-- 草稿状态 -->
            <el-button
              type="text"
              size="mini"
              @click="handleEdit(scope.row)"
            >
              修改
            </el-button>
            <el-button
              type="text"
              size="mini"
              @click="handleSubmit(scope.row)"
            >
              提交
            </el-button>
            <el-button
              type="text"
              size="mini"
              style="color: #F56C6C;"
              @click="handleDelete(scope.row)"
            >
              删除
            </el-button>
          </template>
          
          <template v-else-if="scope.row.state === 2">
            <!-- 已提交状态 -->
            <el-button
              type="text"
              size="mini"
              @click="handleExamine(scope.row)"
            >
              审核
            </el-button>
          </template>
          
          <template v-else-if="scope.row.state === 4">
            <!-- 已审核状态 -->
            <el-button
              type="text"
              size="mini"
              @click="handleConfirm(scope.row)"
            >
              过单/出库
            </el-button>
          </template>
          
          <template v-else-if="scope.row.state === 5">
            <!-- 已过单状态 -->
            <!-- 作废/冲销按钮 -->
            <el-button
              type="text"
              size="mini"
              style="color: #F56C6C;"
              @click="handleCancel(scope.row)"
            >
              作废/冲销
            </el-button>
          </template>
        </template>
      </el-table-column>
    </el-table>
    
    <!-- 分页 -->
    <div class="pagination-container">
      <el-pagination
        :current-page="pagination.pageNum"
        :page-size="pagination.pageSize"
        :total="pagination.totalSize"
        layout="total, sizes, prev, pager, next, jumper"
        :page-sizes="[15, 30, 50, 100]"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        background
      >
      </el-pagination>
    </div>

    <!-- 模态框组件 -->
	<addxyk-modal
	  v-if="showModal"
	  :visible="showModal"
	  :mode="currentMode"
	  :row-data="currentRowData"
	  :putin-type-list="putinTypeList"
	  @close="handleCloseDialog"
	  @success="handleDialogSuccess"
	  @warehouse-switch="handleWarehouseSwitch"
	/>
	<!-- 在适当位置添加导出进度对话框 -->
	<el-dialog title="导出进度" :visible.sync="exporting" width="30%" :close-on-click-modal="false" :show-close="false"
		class="export-progress-dialog">
		<div style="text-align: center;">
			<el-progress type="circle" :percentage="exportProgress"
				:status="exportProgress === 100 ? 'success' : ''"></el-progress>
			<p style="margin-top: 20px; color: #606266;">
				{{ exportProgress === 100 ? '导出完成' : '正在生成导出文件，请稍候...' }}
			</p>
	
			<!-- 导出完成后的操作 -->
			<div v-if="exportProgress === 100" style="margin-top: 20px;">
				<el-button type="primary" size="mini" @click="exporting = false">
					关闭
				</el-button>
				<el-button type="text" size="mini" @click="handleOpenDownloadFolder" v-if="isElectron">
					打开下载文件夹
				</el-button>
			</div>
		</div>
	</el-dialog>
	<div class="excel">
		<!-- Excel导出对话框 -->
		<el-dialog title="Excel批量导出" :visible.sync="excelDialogVisible" width="80%" top="10vh" :modal="false"
			custom-class="excel-import-dialog">
			<div class="excel-import-container">
				<!-- 左侧上传区域 -->
				<div class="left-panel">
					<!-- 上传头部 -->
					<div class="upload-header">
						<el-upload class="upload-demo" drag action="" :auto-upload="false"
							:file-list="excelFileList" :before-upload="beforeExcelUpload"
							:on-change="handleExcelChange" accept=".xlsx, .xls" :multiple="false">
							<i class="el-icon-upload"></i>
							<div class="el-upload__text">将Excel文件拖到此处，或<em>点击上传</em></div>
							<div class="el-upload__tip" slot="tip">
								支持.xls、.xlsx格式，文件大小不超过10MB
								<br>建议使用系统提供的模板文件
							</div>
						</el-upload>
					</div>
	
					<!-- 文件信息区域 -->
					<div class="file-info">
						<div class="file-type-select">
							<el-form label-width="80px" size="mini">
								<el-form-item label="文件类型">
									<el-select v-model="fileType">
										<el-option label="Excel" value="excel"></el-option>
									</el-select>
								</el-form-item>
								<el-form-item label="文件路径">
									<el-input v-model="filePath" placeholder="上传后自动显示文件路径" readonly>
										<el-button slot="append" icon="el-icon-refresh" @click="reSelectFile"
											:disabled="!excelFileList.length">重新选择</el-button>
									</el-input>
								</el-form-item>
							</el-form>
						</div>
	
						<!-- 文件列表表格 -->
						<div class="file-table">
							<el-table :data="fileList" border height="188">
								<el-table-column style="font-size: 12px;" prop="name" label="文件名称"
									width="180"></el-table-column>
								<el-table-column style="font-size: 12px;" prop="path" label="文件路径"
									show-overflow-tooltip></el-table-column>
								<el-table-column style="font-size: 12px;" prop="status" label="状态" width="100">
									<template slot-scope="{row}">
										<el-tag :type="row.status === '导出成功' ? 'success' : 'danger'" size="mini">
											{{row.status}}
										</el-tag>
									</template>
								</el-table-column>
								<el-table-column label="操作" width="80" align="center">
									<template slot-scope="{row}">
										<el-button type="danger" icon="el-icon-del" size="mini" circle
											@click="removeFile(row)"></el-button>
									</template>
								</el-table-column>
							</el-table>
						</div>
					</div>
	
					<!-- 底部操作按钮 -->
					<div class="action-footer">
						<!-- 修改立即执行按钮 -->
						<el-button type="primary" size="medium" @click="submitExcel" :loading="loading"
							:disabled="isSubmitDisabled || !excelTableData.length">
							立即执行
						</el-button>
					</div>
				</div>
	
				<!-- 右侧预览区域 -->
				<div class="right-panel">
					<div class="preview-header">
						<h4>数据预览 (共 {{ excelTableData.length }} 条记录)</h4>
					</div>
	
					<!-- 预览表格 -->
					<div class="preview-table">
						<el-table :data="excelTableData" border height="300" v-loading="loading">
							<el-table-column v-for="col in excelColumns" :key="col.prop" :prop="col.prop"
								:label="col.label" :width="col.width" show-overflow-tooltip></el-table-column>
						</el-table>
					</div>
	
					<!-- 错误信息区域 -->
					<div class="error-info-section" v-if="errorData.length > 0">
						<div class="error-header">
							<h4 style="color: #F56C6C;">
								<i class="el-icon-warning"></i>
								导出错误信息 (共 {{ errorData.length }} 条错误)
							</h4>
							<el-button type="danger" size="mini" icon="el-icon-download" @click="downloadErrorExcel"
								:loading="downloadingError">
								下载错误信息
							</el-button>
						</div>
	
						<!-- 错误信息表格 -->
						<div class="error-table">
							<el-table :data="errorData" border height="300" style="width: 100%" size="mini">
								<!-- 行号列 - 修改：从第1行开始 -->
								<el-table-column label="行号" width="80" align="center" fixed="left">
									<template slot-scope="{ row, $index }">
										<span
											style="font-weight: bold;">第{{ getDisplayRowNumber(row, $index) }}行</span>
									</template>
								</el-table-column>
	
								<!-- 其他列保持不变 -->
								<el-table-column v-for="col in excelColumns" :key="col.prop" :prop="col.prop"
									:label="col.label" :width="col.width" show-overflow-tooltip align="center">
									<template slot-scope="{ row }">
										<span>{{ row[col.prop] || '--' }}</span>
									</template>
								</el-table-column>
	
								<!-- 错误原因列 -->
								<el-table-column prop="errorInfo" label="错误原因" width="200" align="center"
									fixed="right">
									<template slot-scope="{ row }">
										<span
											style="color: #F56C6C; font-weight: bold;">{{ row.errorInfo || '未知错误' }}</span>
									</template>
								</el-table-column>
	
								<!-- 操作列 -->
								<el-table-column label="操作" width="80" align="center" fixed="right">
									<template slot-scope="{ row }">
										<el-button type="text" size="mini" @click="copyErrorInfo(row)">
											复制
										</el-button>
									</template>
								</el-table-column>
							</el-table>
						</div>
					</div>
				</div>
			</div>
		</el-dialog>
	</div>
  </div>
</template>

<script>
import * as XLSX from 'xlsx'; // 使用 * as 导出
import { shopZYReturnList, toZYFRetnExamine, getZYFRetnDetail, docOutDelZYF, selectDropDownList, selectOut, editZYFdocOut } from "@/api/PSI/shopReturn.js";
// excel导出等相关
import { importExcel } from "@/api/systemCatalogue/Western.js";
// 导出
import { exportAllWmDrugDgs } from "@/api/PSI.js";
import AddxykModal from './addzyf.vue';

export default {
  name: 'ZYF',
  components: {
    AddxykModal
  },
  props: {
    filterData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      loading: false,
      tableData: [],
      pagination: {
        pageNum: 1,
        pageSize: 15,
        totalSize: 0
      },
      // 出库类型列表（从接口获取）
      putinTypeList: [],
      // 模态框控制
      showModal: false,
      currentMode: 'add',
      currentRowData: null,
	  
	  excelDialogVisible: false, // 控制Excel导出对话框显示
	  excelFileList: [], // 上传的文件列表
	  excelTableData: [], // 解析后的Excel数据
	  excelColumns: [], // Excel表头
	  uploadUrl: 'http://fsapi.nfcis.cn/outpatitent/excel/西药库出库导出模板.xlsx', // 模拟上传接口
	  uploadHeaders: {
	  	'Authorization': localStorage.getItem('token')
	  },
	  filePath: '',
	  fileList: '',
	  fileType: 'excel',
	  // 判断是否为 Electron 环境
	  isElectron: false,
	  // 错误数据相关状态
	  errorData: [], // 存储错误信息
	  downloadingError: false, // 下载错误信息状态
	  // 导出相关数据
	  exporting: false,
	  exportProgress: 0,
	  exportTimer: null,
	  exportLoading: false, // 导出加载状态
	  // 控制立即执行按钮状态
	  isSubmitDisabled: true,
	  
    };
  },
  created() {
    this.loadPutinTypes();
  },
  mounted() {
    this.loadTableData();
  },
  methods: {
    // 加载出库类型列表
    async loadPutinTypes() {
      try {
        const response = await selectOut();
        if (response && response.data) {
          this.putinTypeList = response.data;
          // 通知父组件更新下拉框选项
          this.$emit('putin-types-loaded', this.putinTypeList);
        }
      } catch (error) {
        console.error('获取出库类型失败:', error);
        this.$message.error('获取出库类型失败');
      }
    },
    
    // 加载表格数据
    async loadTableData() {
      this.loading = true;
      try {
        const params = {
          ...this.filterData,
          pageNum: this.pagination.pageNum,
          pageSize: this.pagination.pageSize
        };
        
        // 处理日期参数
        if (this.filterData.startDate) {
          params.startDate = this.filterData.startDate;
        }
        if (this.filterData.endDate) {
          params.endDate = this.filterData.endDate;
        }
        
        const response = await shopZYReturnList(params);
        
        if (response && response.code === 200) {
          // 从 res.data.content 获取表格数据
          this.tableData = response.data.content || [];
          // 使用 totalSize 作为总条数
          this.pagination.totalSize = response.data.totalSize || response.data.totalElements || 0;
          
          console.log('表格数据加载成功:', {
            data: this.tableData,
            totalSize: this.pagination.totalSize
          });
        } else {
          this.tableData = [];
          this.pagination.totalSize = 0;
        }
      } catch (error) {
        console.error('获取西药库数据失败:', error);
        this.$message.error('获取数据失败');
        this.tableData = [];
        this.pagination.totalSize = 0;
      } finally {
        this.loading = false;
      }
    },
    
    // 格式化金额
    formatAmount(amount) {
      if (!amount && amount !== 0) return '0.00';
      return Number(amount).toLocaleString('zh-CN', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    },
    
    // 格式化时间
    formatTime(time) {
      if (!time) return '--';
      // 如果是时间戳，转换为日期格式
      if (typeof time === 'number') {
        return new Date(time).toLocaleString('zh-CN', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit'
        });
      }
      return time;
    },
    
    // 获取状态文本
    getStatusText(state) {
      const statusMap = {
        0: '草稿',
        1: '提交回退',
        2: '已提交',
        3: '审核回退',
        4: '已审核',
        5: '已过单',
        6: '已冲销'
      };
      return statusMap[state] || '未知';
    },
    
    // 获取出库类型标签样式
    getTypeTagType(retnTypeName) {
      switch(retnTypeName) {
        case '采购出库': return 'danger'; // 采购出库
        case '其他出库': return 'success'; // 其他出库
        case '调拨出库': return 'warning';    // 调拨出库
        case '盘点出库': return 'primary';    // 盘点出库
        default: return 'danger';
      }
    },
    
    // 获取状态标签样式
    getStatusTagType(state) {
      switch(state) {
        case 0: return 'info';        // 草稿
        case 1: return 'info';  // 提交回退
        case 2: return 'warning';    // 已提交
        case 3: return 'warning';  // 审核回退
        case 4: return 'primary';        // 已审核
        case 5: return 'success';  // 已过单
        case 6: return 'danger';   // 已冲销
        default: return 'info';
      }
    },
    
    // 创建出库单
    handleCreateInbound() {
      console.log('创建出库单按钮被点击');
      this.currentMode = 'add';
      this.currentRowData = {}; // 修改这里：从 null 改为空对象
      this.showModal = true;
      
      console.log('父组件状态:', {
        showModal: this.showModal,
        currentMode: this.currentMode,
        currentRowData: this.currentRowData
      });
    },
    
    // 批量出库
    handleBatchInbound() {
      this.handleExcelImport();
    },
    
    // 打开Excel导出对话框
    handleExcelImport() {
    	this.excelDialogVisible = true;
    	this.resetImportData();
    },
    
	// 上传前校验
	beforeExcelUpload(file) {
		const isExcel = file.type.includes('excel') ||
			file.name.endsWith('.xlsx') ||
			file.name.endsWith('.xls');
		const isLt10M = file.size / 1024 / 1024 < 10;
	
		if (!isExcel) {
			this.$message.error('只能上传Excel文件!');
			return false;
		}
		if (!isLt10M) {
			this.$message.error('文件大小不能超过10MB!');
			return false;
		}
		return true;
	},
	
	// 处理文件变化
	handleExcelChange(file, fileList) {
		if (fileList.length > 1) {
			this.excelFileList = [fileList[fileList.length - 1]];
			return;
		}
	
		this.excelFileList = fileList;
		this.filePath = file.name;
		this.excelRawFile = file.raw;
	
		// 清空之前的错误信息
		this.errorData = [];
		this.errorCount = 0;
	
		// 启用立即执行按钮
		this.isSubmitDisabled = false;
	
		// 更新文件列表
		this.fileList = [{
			name: file.name,
			path: file.name,
			status: '待处理'
		}];
	
		// 读取Excel内容
		this.readExcel(file.raw);
	},
	
	// 重新选择文件
	reSelectFile() {
		this.resetImportData();
	},
	
	// 移除文件
	removeFile(row) {
		// 清空所有相关数据
		this.excelFileList = [];
		this.excelTableData = [];
		this.excelColumns = [];
		this.fileList = [];
		this.filePath = '';
		this.errorData = [];
		this.errorCount = 0;
	
		// 重置原始文件对象
		this.excelRawFile = null;
	
		this.$message.info('文件已删除，请重新上传新文件');
	},
	
	// 读取Excel文件
	readExcel(file) {
		this.loading = true;
		const reader = new FileReader();
	
		reader.onload = (e) => {
			try {
				const data = new Uint8Array(e.target.result);
				const workbook = XLSX.read(data, {
					type: 'array'
				});
	
				const firstSheetName = workbook.SheetNames[0];
				const worksheet = workbook.Sheets[firstSheetName];
	
				const jsonData = XLSX.utils.sheet_to_json(worksheet);
	
				if (!jsonData || jsonData.length === 0) {
					this.$message.warning('Excel文件没有数据');
					return;
				}
	
				// 处理表头
				this.excelColumns = Object.keys(jsonData[0]).map(key => ({
					prop: key,
					label: key,
					width: 150
				}));
	
				this.excelTableData = jsonData;
				this.fileList[0].status = '导出成功';
	
				this.$message.success('Excel解析成功');
			} catch (error) {
				////console.error('Excel解析错误:', error);
				this.fileList[0].status = '失败';
				this.$message.error('Excel文件解析失败: ' + error.message);
			} finally {
				this.loading = false;
			}
		};
	
		reader.onerror = (error) => {
			////console.error('文件读取错误:', error);
			this.fileList[0].status = '失败';
			this.$message.error('文件读取失败');
			this.loading = false;
		};
	
		reader.readAsArrayBuffer(file);
	},
	
	// 提交Excel数据
	async submitExcel() {
		if (!this.excelRawFile) {
			this.$message.warning('请先上传Excel文件');
			return;
		}
	
		// 开启全局loading
		this.loading = true;
		// 禁用立即执行按钮
		this.isSubmitDisabled = true;
	
		try {
			const formData = new FormData();
			formData.append('file', this.excelRawFile);
			formData.append('type', 'western');
			formData.append('clinicId', this.$store.getters.clinicId || '');
	
			// 调用导出接口
			const response = await importExcel(formData);
	
			if (response.code === 200) {
				// 关键修改：根据接口返回的数据结构处理
				if (response.data && Object.keys(response.data).length > 0) {
					// 有错误数据，显示错误信息，不关闭模态框
					this.handleImportErrors(response.data);
	
					// 计算成功和失败数量
					const totalCount = this.excelTableData.length;
					const errorCount = Object.keys(response.data).length;
					const successCount = totalCount - errorCount;
	
					this.$message.warning(`导出完成！成功 ${successCount} 条，失败 ${errorCount} 条`);
	
					// 即使有错误数据，也要刷新主表格（因为部分数据可能导出成功）
					this.loadTableData();
	
				} else {
					// 没有错误数据，表示全部导出成功
					this.handleImportSuccess();
				}
			} else {
				this.$message.error(response.message || '导出失败');
			}
		} catch (error) {
			console.error('导出失败:', error);
			this.$message.error('导出失败: ' + (error.message || '网络错误'));
		} finally {
			// 关闭loading，但保持按钮禁用状态直到重新上传文件
			this.loading = false;
		}
	},
	
	// 处理导出成功
	handleImportSuccess() {
		this.$message.success('Excel导出成功！');
	
		// 关闭模态框
		this.excelDialogVisible = false;
	
		// 清空所有数据
		this.resetImportData();
	
		// 刷新主表格数据
		this.loadTableData();
	},
	
	// 重置导出数据
	resetImportData() {
		this.excelFileList = [];
		this.excelTableData = [];
		this.excelColumns = [];
		this.fileList = [];
		this.filePath = '';
		this.errorData = [];
		this.errorCount = 0;
		this.excelRawFile = null;
		this.isSubmitDisabled = true; // 保持禁用直到重新上传
		this.currentPage = 1;
	},
	// 新增：提取错误信息
	extractErrorMessages(errorData) {
		if (!errorData) return '未知错误';
	
		// 如果errorData是字符串，直接返回
		if (typeof errorData === 'string') {
			return errorData;
		}
	
		// 如果errorData是数组，提取所有错误信息
		if (Array.isArray(errorData)) {
			return errorData.map(item => {
				if (typeof item === 'string') return item;
				if (item.message) return item.message;
				if (item.msg) return item.msg;
				return JSON.stringify(item);
			}).join('; ');
		}
	
		// 如果errorData是对象，提取message或msg字段
		if (typeof errorData === 'object') {
			if (errorData.message) return errorData.message;
			if (errorData.msg) return errorData.msg;
	
			// 尝试提取其他可能的错误信息字段
			const possibleErrorFields = ['error', 'errMsg', 'errorMessage', 'detail'];
			for (const field of possibleErrorFields) {
				if (errorData[field]) {
					return errorData[field];
				}
			}
	
			// 如果找不到明确的错误信息字段，返回整个对象
			return JSON.stringify(errorData);
		}
	
		return '未知错误类型';
	},
	
	// 修改：处理导出错误信息
	handleImportErrors(errorData) {
		this.errorData = [];
		this.errorCount = 0;
	
		try {
			console.log('原始错误数据:', errorData);
	
			if (typeof errorData === 'object' && errorData !== null) {
				Object.entries(errorData).forEach(([rowNumber, errorInfo]) => {
					const rowIndex = parseInt(rowNumber);
					const originalRow = this.excelTableData[rowIndex] || {}; // 注意：这里使用rowIndex直接对应数据行
	
					// 创建错误行数据，行号从1开始显示
					const errorRow = {
						id: this.errorData.length + 1,
						rowNumber: rowIndex, // 存储原始行索引（从0开始）
						displayRowNumber: rowIndex + 1, // 新增：显示行号（从1开始）
						errorInfo: errorInfo.msg || this.formatErrorInfo(errorInfo),
						_rawError: errorInfo
					};
	
					// 动态添加预览表格的所有字段
					this.excelColumns.forEach(col => {
						errorRow[col.prop] = originalRow[col.prop] || '--';
					});
	
					this.errorData.push(errorRow);
				});
	
				this.errorCount = this.errorData.length;
			}
	
			console.log('处理后的错误数据:', this.errorData);
	
		} catch (error) {
			console.error('处理错误信息失败:', error);
			this.errorData = [{
				id: 1,
				rowNumber: 0,
				displayRowNumber: 1,
				errorInfo: '处理错误信息时发生异常: ' + error.message,
				_rawError: error
			}];
	
			// 添加预览表格的字段
			this.excelColumns.forEach(col => {
				this.errorData[0][col.prop] = '--';
			});
	
			this.errorCount = 1;
		}
	
		// 数据驱动更新 - 强制重新渲染错误表格
		this.$forceUpdate();
	},
	
	// 新增：格式化错误信息
	formatErrorInfo(errorInfo) {
		if (typeof errorInfo === 'string') {
			return errorInfo;
		} else if (typeof errorInfo === 'object') {
			// 尝试从常见错误字段中提取错误信息
			const errorMessage = errorInfo.message || errorInfo.msg || errorInfo.error ||
				errorInfo.reason || errorInfo.desc || errorInfo.description;
	
			if (errorMessage) {
				return errorMessage;
			}
	
			// 如果是数组，拼接所有错误信息
			if (Array.isArray(errorInfo)) {
				return errorInfo.map(err => this.formatErrorInfo(err)).join('; ');
			}
	
			// 尝试转换为字符串
			try {
				return JSON.stringify(errorInfo);
			} catch (e) {
				return '未知错误格式';
			}
		}
		return '未知错误';
	},
	//  下载错误信息Excel
	// 修改：下载错误信息Excel，行号从1开始
	async downloadErrorExcel() {
		if (this.errorData.length === 0) {
			this.$message.warning('没有错误信息可下载');
			return;
		}
	
		this.downloadingError = true;
	
		try {
			// 创建工作簿
			const workbook = XLSX.utils.book_new();
	
			// 准备错误数据 - 行号从1开始
			const errorDataForExport = this.errorData.map((errorRow, index) => {
				const exportRow = {
					'行号': errorRow.displayRowNumber || (index + 1) // 使用显示行号或索引+1
				};
	
				// 添加预览表格的所有字段
				this.excelColumns.forEach(col => {
					exportRow[col.label] = errorRow[col.prop] || '--';
				});
	
				// 添加错误原因
				exportRow['错误原因'] = errorRow.errorInfo || '未知错误';
	
				return exportRow;
			});
	
			// 创建工作表
			const worksheet = XLSX.utils.json_to_sheet(errorDataForExport);
	
			// 设置列宽
			const colWidths = [{
					wch: 8
				}, // 行号
			];
	
			// 添加预览表格列的宽度
			this.excelColumns.forEach(col => {
				colWidths.push({
					wch: col.width ? col.width / 10 : 15
				});
			});
	
			// 错误原因列宽度
			colWidths.push({
				wch: 40
			});
	
			worksheet['!cols'] = colWidths;
	
			// 添加工作表到工作簿
			XLSX.utils.book_append_sheet(workbook, worksheet, '导出错误信息');
	
			// 生成Excel文件
			const excelBuffer = XLSX.write(workbook, {
				bookType: 'xlsx',
				type: 'array'
			});
	
			// 创建Blob并下载
			const blob = new Blob([excelBuffer], {
				type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
			});
			const url = URL.createObjectURL(blob);
			const link = document.createElement('a');
	
			// 生成带时间戳的文件名
			this.watermarkText = localStorage.getItem('watermarkText') || '西药库';
			const timestamp = new Date().toISOString().slice(0, 19).replace(/:/g, '-');
			const fileName = `${this.watermarkText}出库导出错误信息_${timestamp}.xlsx`;
	
			link.href = url;
			link.download = fileName;
			document.body.appendChild(link);
			link.click();
	
			// 清理
			setTimeout(() => {
				document.body.removeChild(link);
				URL.revokeObjectURL(url);
			}, 100);
	
			this.$message.success(`错误信息Excel文件已下载，共 ${this.errorData.length} 条错误记录`);
	
		} catch (error) {
			console.error('下载错误信息失败:', error);
			this.$message.error('下载错误信息失败: ' + error.message);
		} finally {
			this.downloadingError = false;
		}
	},
	
	// 修改：复制错误信息，包含所有字段
	copyErrorInfo(row) {
		// 构建包含所有字段的错误信息文本
		let errorText = `行号: ${row.rowNumber || '未知'}\n`;
	
		// 添加预览表格的所有字段
		this.excelColumns.forEach(col => {
			errorText += `${col.label}: ${row[col.prop] || '--'}\n`;
		});
	
		errorText += `错误原因: ${row.errorInfo || '未知错误'}`;
	
		// 使用Clipboard API（现代浏览器）
		if (navigator.clipboard && window.isSecureContext) {
			navigator.clipboard.writeText(errorText).then(() => {
				this.$message.success('错误信息已复制到剪贴板');
			}).catch(err => {
				// 降级方案
				this.fallbackCopyText(errorText);
			});
		} else {
			// 降级方案
			this.fallbackCopyText(errorText);
		}
	},
	
	// 导出功能 - 优化版本
	async handleExport() {
		this.$confirm('确定要导出出库出库数据吗？', '导出确认', {
			confirmButtonText: '确定导出',
			cancelButtonText: '取消',
			type: 'warning'
		}).then(async () => {
			await this.handleExportData();
		}).catch(() => {
			this.$message.info('已取消导出');
		});
	},
	
	// 执行导出
	async handleExportData() {
		this.exporting = true;
		this.exportProgress = 0;
	
		try {
			// 开始进度模拟
			this.startExportProgress();
	
			// 调用导出接口
			const response = await exportAllWmDrugDgs();
	
			if (response) {
				await this.processExportData(response);
				this.$message.success('导出成功，文件正在下载中...');
			} else {
				this.$message.error('导出数据为空');
			}
		} catch (error) {
			console.error('导出失败:', error);
			this.$message.error('导出失败: ' + (error.message || '未知错误'));
	
			// 尝试处理可能的错误响应
			try {
				if (error.response && error.response.data) {
					const errorData = error.response.data;
					if (typeof errorData === 'string' && errorData.includes('{')) {
						const errorInfo = JSON.parse(errorData);
						this.$message.error(errorInfo.message || errorInfo.msg || '导出接口返回错误');
					}
				}
			} catch (parseError) {
				// 忽略解析错误
			}
		} finally {
			this.finishExport();
		}
	},
	
	// 开始导出进度模拟
	startExportProgress() {
		this.exportProgress = 0;
		this.exportTimer = setInterval(() => {
			if (this.exportProgress < 90) {
				this.exportProgress += 10;
			}
		}, 300);
	},
	
	// 完成导出
	finishExport() {
		this.exportProgress = 100;
		setTimeout(() => {
			if (this.exportTimer) {
				clearInterval(this.exportTimer);
				this.exportTimer = null;
			}
			this.exporting = false;
			this.exportProgress = 0;
		}, 500);
	},
	
	// 处理导出数据
	async processExportData(blobData) {
		try {
			// 检查blobData是否为有效的Blob对象
			if (!(blobData instanceof Blob)) {
				console.error('返回的数据不是Blob对象:', typeof blobData);
	
				// 尝试将数据转换为文本，检查是否是错误信息
				if (typeof blobData === 'string') {
					try {
						const errorInfo = JSON.parse(blobData);
						this.$message.error(errorInfo.message || errorInfo.msg || '导出接口返回错误信息');
					} catch (e) {
						this.$message.error('导出数据格式错误: ' + blobData.substring(0, 100));
					}
				} else {
					this.$message.error('导出数据格式不正确，请联系管理员');
				}
				return false;
			}
	
			// 检查Blob的大小，如果太小可能是错误信息
			if (blobData.size < 100) {
				const text = await this.blobToText(blobData);
				try {
					const errorInfo = JSON.parse(text);
					this.$message.error(errorInfo.message || errorInfo.msg || '导出数据为空或格式错误');
				} catch (e) {
					console.log('Blob内容:', text);
					this.$message.error('导出文件可能已损坏，请联系管理员');
				}
				return false;
			}
	
			// 验证文件类型
			const isValidExcel = blobData.type ===
				'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
				blobData.type === 'application/vnd.ms-excel' ||
				blobData.type === 'application/octet-stream';
	
			if (!isValidExcel) {
				// 可能是错误信息，尝试读取
				const text = await this.blobToText(blobData);
				try {
					const errorInfo = JSON.parse(text);
					this.$message.error(errorInfo.message || errorInfo.msg || '导出失败');
				} catch (e) {
					this.$message.error('服务器返回非Excel文件: ' + text.substring(0, 200));
				}
				return false;
			}
	
			// 创建下载链接
			const url = window.URL.createObjectURL(blobData);
			const link = document.createElement('a');
	
			// 生成文件名
			const warehouseName = '西药库';
			const timestamp = new Date();
			const dateStr = timestamp.toLocaleDateString('zh-CN', {
				year: 'numeric',
				month: '2-digit',
				day: '2-digit'
			}).replace(/\//g, '');
	
			const timeStr = timestamp.toLocaleTimeString('zh-CN', {
				hour: '2-digit',
				minute: '2-digit',
				second: '2-digit'
			}).replace(/:/g, '');
	
			const fileName = `${warehouseName}出库导出_${dateStr}_${timeStr}.xlsx`;
	
			// 设置下载属性
			link.href = url;
			link.download = fileName;
			link.style.display = 'none';
	
			// 添加到DOM并触发点击
			document.body.appendChild(link);
	
			// 添加点击事件处理，确保下载完成后再清理
			link.onclick = () => {
				setTimeout(() => {
					document.body.removeChild(link);
					window.URL.revokeObjectURL(url);
				}, 100);
			};
	
			link.click();
	
			console.log('文件下载信息:', {
				文件大小: blobData.size + ' bytes',
				文件类型: blobData.type,
				文件名: fileName
			});
	
			return true;
	
		} catch (error) {
			console.error('处理导出数据失败:', error);
	
			// 尝试将错误信息转换为可读格式
			if (error.response && error.response.data) {
				try {
					const errorText = await this.blobToText(error.response.data);
					const errorInfo = JSON.parse(errorText);
					this.$message.error(errorInfo.message || errorInfo.msg || '导出处理失败');
				} catch (parseError) {
					this.$message.error('导出失败: ' + error.message);
				}
			} else {
				this.$message.error('导出失败: ' + (error.message || '未知错误'));
			}
			return false;
		}
	},
	
	// 新增：Blob转文本工具方法
	blobToText(blob) {
		return new Promise((resolve, reject) => {
			const reader = new FileReader();
			reader.onload = () => resolve(reader.result);
			reader.onerror = reject;
			reader.readAsText(blob);
		});
	},
	// 获取显示行号（从1开始）
	getDisplayRowNumber(row, index) {
		// 优先使用row中的rowNumber，如果没有则使用索引+1
		if (row.rowNumber !== undefined && row.rowNumber !== null) {
			return parseInt(row.rowNumber) + 1;
		}
		return index + 1;
	},
	
	// 降级复制方案
	fallbackCopyText(text) {
		const textArea = document.createElement('textarea');
		textArea.value = text;
		textArea.style.position = 'fixed';
		textArea.style.top = 0;
		textArea.style.left = 0;
		textArea.style.opacity = 0;
		document.body.appendChild(textArea);
		textArea.focus();
		textArea.select();
	
		try {
			const successful = document.execCommand('copy');
			if (successful) {
				this.$message.success('错误信息已复制到剪贴板');
			} else {
				this.$message.error('复制失败，请手动复制');
			}
		} catch (err) {
			this.$message.error('复制失败: ' + err);
		}
	
		document.body.removeChild(textArea);
	},
	
	// 显示错误详情
	showErrorDetails(errorData) {
		// 这里可以打开一个模态框显示详细的错误信息
		let errorMessage = '导出错误详情:\n\n';
	
		if (Array.isArray(errorData)) {
			errorData.forEach((error, index) => {
				errorMessage += `${index + 1}. ${this.formatError(error)}\n`;
			});
		} else if (typeof errorData === 'object') {
			Object.entries(errorData).forEach(([key, value], index) => {
				errorMessage += `${index + 1}. ${key}: ${this.formatError(value)}\n`;
			});
		}
	
		// 使用Element UI的alert显示错误详情
		this.$alert(errorMessage, '导出错误详情', {
			confirmButtonText: '确定',
			customClass: 'error-details-dialog',
			dangerouslyUseHTMLString: false
		});
	},
	
    // 父组件中的各个处理方法，确保正确传递id - > 查看详情
    // 查看详情
    async handleView(row) {
      try {
        this.loading = true;
        const response = await getZYFRetnDetail({ id: row.id });
        
        if (response && response.code === 200) {
          this.currentMode = 'view';
          this.currentRowData = {
            ...response.data,
            id: row.id,
            docNum: row.docNum
          };
          this.showModal = true;
        } else {
          this.$message.error(response.message || '获取详情失败');
        }
      } catch (error) {
        console.error('获取详情失败:', error);
        this.$message.error('获取详情失败');
      } finally {
        this.loading = false;
      }
    },

	
    // 修改
    async handleEdit(row) {
      try {
        this.loading = true;
        const response = await getZYFRetnDetail({ id: row.id });
        
        if (response && response.code === 200) {
          this.currentMode = 'edit';
          this.currentRowData = {
            ...response.data,
            id: row.id,
            docNum: row.docNum
          };
          this.showModal = true;
        } else {
          this.$message.error(response.message || '获取数据失败');
        }
      } catch (error) {
        console.error('获取数据失败:', error);
        this.$message.error('获取数据失败');
      } finally {
        this.loading = false;
      }
    },
    
    // 提交
    async handleSubmit(row) {
      try {
        this.loading = true;
        const response = await getZYFRetnDetail({ id: row.id });
        
        if (response && response.code === 200) {
          this.currentMode = 'submit';
          this.currentRowData = {
            ...response.data,
            id: row.id,
            docNum: row.docNum
          };
          this.showModal = true;
        } else {
          this.$message.error(response.message || '获取数据失败');
        }
      } catch (error) {
        console.error('获取数据失败:', error);
        this.$message.error('获取数据失败');
      } finally {
        this.loading = false;
      }
    },
    
    // 审核
    async handleExamine(row) {
      try {
        this.loading = true;
        const response = await getZYFRetnDetail({ id: row.id });
        
        if (response && response.code === 200) {
          this.currentMode = 'review';
          this.currentRowData = {
            ...response.data,
            id: row.id,
            docNum: row.docNum
          };
          this.showModal = true;
        } else {
          this.$message.error(response.message || '获取数据失败');
        }
      } catch (error) {
        console.error('获取数据失败:', error);
        this.$message.error('获取数据失败');
      } finally {
        this.loading = false;
      }
    },
    
    // 确认出库/过单
    async handleConfirm(row) {
      try {
        this.loading = true;
        const response = await getZYFRetnDetail({ id: row.id });
        
        if (response && response.code === 200) {
          this.currentMode = 'pass';
          this.currentRowData = {
            ...response.data,
            id: row.id,
            docNum: row.docNum
          };
          this.showModal = true;
        } else {
          this.$message.error(response.message || '获取数据失败');
        }
      } catch (error) {
        console.error('获取数据失败:', error);
        this.$message.error('获取数据失败');
      } finally {
        this.loading = false;
      }
    },
    
    // 删除
    async handleDelete(row) {
      try {
        await this.$confirm(`确认删除（${row.docNum}）这条出库单吗？`, '提示', {
          type: 'warning'
        });
        
        // 调用删除接口
        const response = await docOutDelZYF({ id: row.id });
        if (response && response.code === 200) {
          this.$message.success(`西药库出库单（${row.docNum}）- 草稿 - 已删除`);
          this.loadTableData();
        } else {
          this.$message.error(response.message || '删除失败');
        }
      } catch (error) {
        if (error !== 'cancel') {
          console.error('删除失败:', error);
          this.$message.error('删除失败');
        }
      }
    },
    
    // 回退
    async handleRollback(row) {
      try {
        this.loading = true;
        const response = await getZYFRetnDetail({ id: row.id });
        
        if (response && response.code === 200) {
          this.currentMode = 'rollback';
          // 确保传递的rowData中包含正确的id
          this.currentRowData = {
            ...response.data,
            id: row.id, // 确保id正确传递
            docNum: row.docNum // 确保出库单号正确传递
          };
          this.showModal = true;
        } else {
          this.$message.error(response.message || '获取数据失败');
        }
      } catch (error) {
        console.error('获取数据失败:', error);
        this.$message.error('获取数据失败');
      } finally {
        this.loading = false;
      }
    },
    
    // 作废/冲销
    async handleCancel(row) {
      try {
        await this.$confirm(`确认冲销（${row.docNum}）这条出库单吗？`, '提示', {
          type: 'warning'
        });
        
        // 调用作废接口，状态为6
        const response = await toZYFRetnExamine({
          id: row.id, // 使用表格行的id
          state: 6
        });
        
        if (response && response.code === 200) {
          this.$message.success('冲销成功');
          this.loadTableData();
        } else {
          this.$message.error(response.message || '冲销失败');
        }
      } catch (error) {
        if (error !== 'cancel') {
          console.error('冲销失败:', error);
          this.$message.error('冲销失败');
        }
      }
    },
    
    // 快速调拨
    handleQuickAllot(row) {
      console.log('快速调拨:', row);
      this.$message.info('快速调拨功能待实现');
    },
    
	// 处理出库/退库
	handleOutbound() {
	  // 使用fade淡出淡出过渡动画跳转到/PSI/XyRet页面
	  this.$router.push('/PSI/XyRet');
	},
		
    // 搜索
    handleSearch() {
      this.pagination.pageNum = 1;
      this.loadTableData();
    },
    
    // 分页大小变化
    handleSizeChange(size) {
      this.pagination.pageSize = size;
      this.pagination.pageNum = 1;
      this.loadTableData();
    },
    
    // 当前页变化
    handleCurrentChange(page) {
      this.pagination.pageNum = page;
      this.loadTableData();
    },
    
    // 关闭对话框
    handleCloseDialog() {
      this.showModal = false;
      this.currentMode = 'add';
      this.currentRowData = null;
    },
    
    // 处理出库单创建成功后的药库切换
	async handleDialogSuccess(data) {
	  console.log('出库单创建成功，返回数据:', data);
	  
	  this.showModal = false;
	  this.currentMode = 'add';
	  this.currentRowData = null;
	  
	  // 如果创建的是西药房的出库单，自动切换到西药房视图
	  if (data && data.warehouseId === 2) {
		// 触发事件通知父组件切换药库
		this.$emit('switch-warehouse', 2);
		this.$message.success('已自动切换到西药房列表');
	  }
	  
	  // 刷新表格数据
	  this.loadTableData();
	},
	// 处理药库切换请求
	handleWarehouseSwitch(warehouseId) {
	  console.log('收到药库切换请求:', warehouseId);
	  this.$emit('switch-warehouse', warehouseId);
	},
  },
  watch: {
	  showModal(newVal) {
	      console.log('父组件showModal变化:', newVal);
	    },
    // 监听筛选条件变化
    filterData: {
      handler(newVal) {
        this.pagination.pageNum = 1;
        this.loadTableData();
      },
      deep: true
    }
  }
};
</script>

<style lang="less" scoped>
.warehouse-component {
  height: 100%;
  display: flex;
  flex-direction: column;
  
  .operation-buttons {
    padding: 10px 16px;
    background-color: #fff;
    border-bottom: 1px solid #e8e8e8;
    display: flex;
    gap: 10px;
  }
  
  .pagination-container {
    padding: 12px 16px;
    background-color: #fff;
    border-top: 1px solid #e8e8e8;
    display: flex;
    justify-content: flex-end;
  }
  
  .doc-num-link {
    color: #409EFF;
    font-weight: 500;
    cursor: pointer;
    font-size: 12px;
    &:hover {
      color: #66b1ff;
      text-decoration: underline;
    }
  }
  
  .amount {
    color: #F56C6C;
    font-weight: 600;
  }
  .excel {
  	display: flex;
  	align-items: center;
  	justify-content: center;
	
	/deep/ .el-dialog {
		border-radius: 10px;
	}
  	/deep/ .el-dialog__header {
  		padding: 8px;
		border-radius: 10px 10px 0 0;
  		background-color: #00aaff;
  	}
  
  	/deep/ .el-dialog__title {
  		color: #fff;
  		font-size: 12px;
  	}
  
  	/deep/ .el-dialog__headerbtn {
  		top: 15px;
  	}
  
  	/deep/ .el-dialog__headerbtn .el-dialog__close {
  		color: #fff;
  	}
  
  	/deep/ .el-dialog__headerbtn .el-dialog__close:hover {
  		background-color: brown;
  	}
  
  	/deep/ .el-table .cell {
  		font-size: 12px;
  		font-weight: 400;
  		color: #0c0c0c;
  		text-align: left;
  	}
  
  	/* Excel导出样式 */
  	.excel-import-dialog {
  		.el-dialog__body {
  			padding: 10px 20px;
  		}
  	}
  
  	.excel-import-container {
  		display: flex;
  		height: 600px;
  
  		.left-panel {
  			flex: 1;
  			display: flex;
  			flex-direction: column;
  			padding-right: 15px;
  			border-right: 1px solid #ebeef5;
  
  			.upload-header {
  				padding: 10px 0;
  
  				.upload-demo {
  					text-align: center;
  				}
  			}
  
  			.file-info {
  				flex: 1;
  				display: flex;
  				flex-direction: column;
  
  				.file-type-select {
  					padding: 10px 0;
  
  					.el-form-item {
  						margin-bottom: 10px;
  					}
  				}
  
  				.file-table {
  					flex: 1;
  					overflow: hidden;
  				}
  			}
  
  			.action-footer {
  				padding: 10px 0;
  				text-align: center;
  
  				.el-button {
  					width: 100%;
  				}
  			}
  		}
  
  		.right-panel {
  			flex: 2;
  			display: flex;
  			flex-direction: column;
  			padding-left: 15px;
  			overflow: hidden;
  
  			/* 防止整体溢出 */
  			.preview-header {
  				padding: 10px 0;
  				border-bottom: 1px solid #ebeef5;
  
  				h4 {
  					margin: 0;
  					font-size: 14px;
  					color: #606266;
  				}
  			}
  
  			.preview-table {
  				flex: 1;
  				width: 100%;
  				overflow: hidden;
  			}
  
  			.pagination-footer {
  				padding: 10px 0;
  				text-align: center;
  				border-top: 1px solid #ebeef5;
  			}
  		}
  	}
  
  	.el-upload-dragger {
  		width: 100%;
  		padding: 20px;
  	}
  
  	.el-upload__tip {
  		font-size: 12px;
  		color: #909399;
  		margin-top: 5px;
  	}
  }
}
</style>